import AppConfigs from './AppConfigs';

// All app preference keys
const PreferenceKeys = {
  // token
  accessToken: `${AppConfigs.packageName}_accessToken`,
  socketToken: `${AppConfigs.packageName}_socketToken`,
  accessTokenExpired: `${AppConfigs.packageName}_accessTokenExpired`,
  // login info
  savedLoginEmail: `${AppConfigs.packageName}_savedLoginEmail`,
  savedLoginPassword: `${AppConfigs.packageName}_savedLoginPassword`,
  savedActiveRole: `${AppConfigs.packageName}_savedActiveRole`,
};

export default PreferenceKeys;
